<template>
  <div id="search">
    <v-layout wrap>
      <v-flex sm4 md3 class="border-right" v-show="searchResults.length > 0">
        <results></results>
      </v-flex>
      <v-flex sm8 md9 v-show="selectedCompanies.length > 0">
        <div>
          <v-tabs color="secondary" dark slider-color="yellow" v-model="active">
            <v-tab v-for="item in selectedCompanies" :key="item.Id" @click.middle="REMOVE_COMPANIES(item)"
              :href="`#tab-${item.Id}`">
              {{ truncate(item.Name) }}
              <v-btn icon color="grey" small class="close-button" @click="REMOVE_COMPANIES(item)">
                <v-icon>close</v-icon>
              </v-btn>
            </v-tab>
            <v-tab-item v-for="item in selectedCompanies" :key="item.Id" :value="`tab-${item.Id}`">
              <vue-perfect-scrollbar class="drawer-menu--scroll" :settings="scrollSettings">
                <v-card flat>
                  <div>
                    <company-info :data="item" @updateCompany="handleSuccessUpdateCompany"></company-info>
                  </div>

                  <div>
                    <v-tabs color="primary" dark slider-color="yellow" fixed-tabs>
                      <v-tab ripple key="bitrix24">Bitrix24 CRM</v-tab>
                      <v-tab ripple key="suite">Suite CRM</v-tab>
                      <v-tab ripple key="billing">Billing</v-tab>
                      <v-tab ripple key="admin">Admin Tool</v-tab>
                      <v-tab ripple key="sc-v4">SC V4</v-tab>
                      <v-tab ripple key="monitor">Monitor Package</v-tab>
                      <!-- <v-tab ripple key="send-command">Send Command</v-tab> -->
                      <v-tab-item key="bitrix24">
                        <v-card flat>
                          <crm-bitrix :trackingId="item.Id"></crm-bitrix>
                        </v-card>
                      </v-tab-item>
                      <v-tab-item key="suite">
                        <v-card flat>
                          <crm-info ref="crmInfo" :trackingId="item.Id"></crm-info>
                        </v-card>
                      </v-tab-item>
                      <v-tab-item key="billing">
                        <v-card flat>
                          <billing-statuses :name="item.Name" :id="item.Id"></billing-statuses>
                        </v-card>
                      </v-tab-item>
                      <v-tab-item key="admin">
                        <v-card flat>
                          <admin-tool :name="item.Name" :vehicles="item.Vehicles" :devices="item.Devices"></admin-tool>
                        </v-card>
                      </v-tab-item>
                      <v-tab-item key="sc-v4">
                        <v-card flat>
                          <new-s-c :name="item.Name" :vehicles="item.Vehicles" :devices="item.Devices">
                          </new-s-c>
                        </v-card>
                      </v-tab-item>

                      <v-tab-item key="monitor">
                        <v-card flat>
                          <monitor-package 
                           :name="item.Name"
                           :vehicles="item.Vehicles" 
                           :devices="item.Devices">
                          </monitor-package>
                        </v-card>
                      </v-tab-item>

                      <!-- <v-tab-item key="send-command">
                        <v-card flat>
                          <send-command
                            :name="item.Name"
                            :vehicles="item.Vehicles"
                            :devices="item.Devices"
                          ></send-command>
                        </v-card>
                      </v-tab-item> -->
                    </v-tabs>
                  </div>
                </v-card>
              </vue-perfect-scrollbar>
            </v-tab-item>
          </v-tabs>
        </div>
      </v-flex>
      <v-flex v-show="searchResults.length === 0">
        <div v-show="searchResults.length === 0" class="search-empty">
          <v-icon class="search-empty-icon" color="primary">search</v-icon>
          <v-text-field v-model="searchText" :loading="loading" :disabled="loading" v-on:keyup.enter="search()"
            class="search-empty-textfield" solo placeholder="Tìm kiếm theo User, Biển số xe"></v-text-field>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
// import VuePostmessage from 'vue-postmessage';
import { mapGetters, mapActions, mapMutations } from 'vuex';
import * as Utils from '@/utils';

import validate from '@/utils/validate';

import * as Auth from '@/utils/auth';

import VuePerfectScrollbar from 'vue-perfect-scrollbar';

import Results from './components/Results';

import CompanyInfo from './components/CompanyInfo';

import CrmInfo from './components/CrmInfo';

import BillingStatuses from './components/BillingStatuses';
import AdminTool from './components/AdminTool';
import CrmBitrix from './components/CrmBitrix';
import NewSC from './components/NewSC';
import MonitorPackage from './components/MonitorPackage';
import SendCommand from './components/SendCommand';
// Vue.use(VuePostmessage);
export default {
  components: {
    Results,
    CompanyInfo,
    CrmInfo,
    VuePerfectScrollbar,
    BillingStatuses,
    AdminTool,
    CrmBitrix,
    // Sim,
    NewSC,
    MonitorPackage,
    SendCommand,
  },
  data() {
    return {
      scrollSettings: { maxScrollbarLength: 160 },
      searchText: '',
      loading: false,
      active: null,
      // lưu xe được chọn per company: { [companyId]: vehicleObject }
      selectedVehiclePerCompany: {},
      // per-company inner tabs index
      innerTab: {},
    };
  },

  computed: {
    ...mapGetters([
      'loggedUser',
      'selectedCompanies',
      'searchResults',
      'token',
    ]),
  },

  watch: {
    // eslint-disable-next-line space-before-function-paren
    selectedCompanies() {
      // console.log('TCL: selectedCompanies -> selectedCompanies', JSON.stringify(this.selectedCompanies));
      if (this.selectedCompanies.length > 0) {
        this.active =
          'tab-' +
          this.selectedCompanies[this.selectedCompanies.length - 1].Id;
      }

      // ensure each company has its own innerTab index (default 0)
      (this.selectedCompanies || []).forEach(c => {
        if (c && c.Id != null && this.innerTab[c.Id] == null) {
          this.$set(this.innerTab, c.Id, 0);
        }
      });

      this.$forceUpdate();
    },
  },

  // eslint-disable-next-line space-before-function-paren
  mounted() {
    if (!Auth.getAccessToken()) window.location.href = Auth.getURLAuthorize();
  },

  methods: {
    ...mapActions(['SeachCompanyRequest']),
    ...mapMutations(['REMOVE_COMPANIES', 'SET_SEARCH_TEXT']),
    // gọi khi CompanyInfo emit sự kiện chọn xe
    handleSelectVehicle(company, vehicle) {
      if (!company || !company.Id) return;
      // đảm bảo reactivity
      this.$set(this.selectedVehiclePerCompany, company.Id, vehicle);
    },
    selectedVehicleFor(companyId) {
      return this.selectedVehiclePerCompany[companyId] || null;
    },
    // eslint-disable-next-line space-before-function-paren
    truncate(text) {
      return text.length > 20 ? text.substring(0, 20) + '...' : text;
    },

    // eslint-disable-next-line space-before-function-paren
    search() {
      if (this.searchText) {
        let keywordRemovedVietnamese = this.searchText;
        this.SET_SEARCH_TEXT(this.searchText);
        this.loading = true;

        let key = keywordRemovedVietnamese;
        if (
          keywordRemovedVietnamese.startsWith('/') ||
          keywordRemovedVietnamese.startsWith('"')
        ) {
          key = keywordRemovedVietnamese.replace('/', '');
          key = keywordRemovedVietnamese.replace('"', '');
        } else {
          key = validate.transferVietnamese(this.searchText);
        }

        this.SeachCompanyRequest({ Key: key })
          .catch((error) => {
            console.log(error);
            window.getApp.showMessage(
              'Có lỗi xảy ra, vui lòng thử lại sau',
              'error'
            );
          })
          .finally((_) => {
            this.loading = false;
          });
      }
    },
    // eslint-disable-next-line space-before-function-paren
    handleSuccessUpdateCompany(data) {
      let index = this.selectedCompanies.findIndex(
        (item) => item.Id === data.Id
      );
      let account = {
        Address: data.Address,
        Name: data.Name,
        FullName: data.FullName,
        Phone: data.Phone,
        PrimaryContactPhone: data.ContactPhone,
        PrimaryContactName: data.ContactName,
        PrimaryContactEmail: data.ContactEmail,
        Remark: data.Remark,
      };
      this.$refs.crmInfo[index].account = {
        ...this.$refs.crmInfo[index].account,
        ...account,
      };
    },
  },
};
</script>

<style scoped>
.drawer-menu--scroll {
  height: calc(100vh - 116px);
  overflow: auto;
}

.border-right {
  border-right: 1px solid #e0e0e0;
}

.close-button {
  height: 20px !important;
  width: 20px !important;
  margin-left: 20px important;
}

.v-icon {
  font-size: 10pt !important;
}

.search-box {
  padding: 12px 12px 0px 12px !important;
  margin-bottom: -12px !important;
}

.search-empty {
  padding-top: 25vh;
  width: 100%;
  text-align: center;
}

.search-empty-icon {
  font-size: 128pt !important;
}

.search-empty-textfield {
  width: 40% !important;
  margin-left: 30% !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/search/index.vue